import styled, { css } from "styled-components"

export const Container = styled.div`
    display: flex;
    align-items: center;

    .inputCheck{
        margin-right: 1rem;
        min-width: 2rem;
    }   


    & + &{
        margin-top: 1rem;
    }


    .moreBusinessInfo{
        font-size: 0.8rem;
        font-weight: 500;

        div {
            background: var(--colorBackgroundCardsDashboard);
            width: max-content;
            padding: 0.3rem;
            font-size: 0.7rem;
            color: var(--colorFontsCardsDashboard);
        }

        display: flex;
        align-items: center;
        gap: 0.5rem;
    }


    @media (min-width: 960px){
        cursor: pointer;
    }
`

export const ContentBusiness = styled.div`
    flex: auto;
    position: relative;
    margin: 0 0.2rem;

    &::before{
        content: attr(data-sync);
        padding: 1rem;
        width: max-content;
        background: #FFF;
        text-align: center;
        border-radius: .3rem;
        box-shadow: 0 2px 4px rgb(0 0 0 / 10%), 0 8px 16px rgb(0 0 0 / 10%);
        font-size: 0.85rem;
        font-weight: 900;
        z-index: 99;

        display: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%) translateY(70%);
    }

    &:hover::before{
        display: block;
    }
`

export const StatusSync = styled.div`
    margin-right: 0.2rem;
    display: inline-block;

    position: absolute;
    top: -7px;
    left: -10px;

     svg{
        font-size: 0.5rem;
        color: #cc0000;
        
        ${props => props.updated && css`
            color: green;
            animation-duration: 1.5s;
            animation-name: blinking;
            animation-iteration-count: infinite;
        `}
    }


    @keyframes blinking{
        0% {color:  #00800099}
        50% {color: #008000CC}
        100% {color: #008000}          
    }
`

export const AdditionalSettings = styled.div`
    color: gray;
    font-size: 1.2rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .idCustomizedContainer {
        position: absolute;
        right: 0;
        transform: translateX(-10%);

        div {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.2rem;
        }
    }

    form {
        background: #FFF;
        padding: 1rem;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgb(0 0 0 / 5%), 0 8px 16px rgb(0 0 0 / 5%);

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 0.2rem;

        label {
            font-size: 0.9rem;
        }

        button {
            border: none;
            font-size: 1.2rem;

            display: flex;
            align-items: center;
            justify-content: center;
        }

        svg {
            color: var(--mainTheme);
        }
    }

    ${props => props.isLoading && css`
        pointer-events: none;
        opacity: 0.5;
    `}
`